import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course02 from "../../../course/course-02/course";
import lesson0206 from "../../../lesson/course-02/lesson-06/lesson";
import lesson0207 from "../../../lesson/course-02/lesson-07/lesson";
import lesson0208 from "../../../lesson/course-02/lesson-08/lesson";
import lesson0209 from "../../../lesson/course-02/lesson-09/lesson";
import lesson0210 from "../../../lesson/course-02/lesson-10/lesson";
import lesson0211 from "../../../lesson/course-02/lesson-11/lesson";
import lesson0212 from "../../../lesson/course-02/lesson-12/lesson";
import lesson0214 from "../../../lesson/course-02/lesson-14/lesson";
import lesson0216 from "../../../lesson/course-02/lesson-16/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "3da77a96-9928-43f1-9acd-bfee1343de14",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0206),
    lesson: lesson0206,
  },
  {
    id: "d2061ba9-779f-460f-bc5d-887a0f28c572",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0207),
    lesson: lesson0207,
  },
  {
    id: "2f0d011c-2674-4e7c-b7bd-33879767a125",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0208),
    lesson: lesson0208,
  },
  {
    id: "6a53d8fa-85c8-4dd0-8a5e-3a2a1f8e85fb",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0209),
    lesson: lesson0209,
  },
  {
    id: "6f67c77e-393a-413c-99b3-314b60f3feeb",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0210),
    lesson: lesson0210,
  },
  {
    id: "b0397d34-167b-4009-8932-56adec5bf031",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0211),
    lesson: lesson0211,
  },
  {
    id: "c9c253db-521e-4fb0-b614-c7fb9f784131",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0212),
    lesson: lesson0212,
  },
  {
    id: "4fee0697-17a7-4e24-baee-1ff6b66ff1ca",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0214),
    lesson: lesson0214,
  },
  {
    id: "faceb57c-c239-40af-a8ed-b6c823549d73",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0216),
    lesson: lesson0216,
  },
];

export default lessonLinks;
